import { render, staticRenderFns } from "./subordinate.vue?vue&type=template&id=74f4e49b&scoped=true&"
import script from "./subordinate.vue?vue&type=script&lang=js&"
export * from "./subordinate.vue?vue&type=script&lang=js&"
import style0 from "./subordinate.vue?vue&type=style&index=0&id=74f4e49b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f4e49b",
  null
  
)

export default component.exports